import { api } from "@/api/axios.ts";
import {
  ApiAnalyticsTimeOffBalanceFilter,
  ApiAnalyticsTimeOffBalanceReport,
  ApiAnalyticsTimeOffBalanceSummaryFilter,
  ApiAnalyticsTimeOffBalanceSummaryReport,
  ApiAnalyticsTimeOffLeavePolicyFilter,
  ApiAnalyticsTimeOffLeavePolicyReport,
  ApiAnalyticsTimeOffLeaveUsedFilter,
  ApiAnalyticsTimeOffLeaveUsedReport,
} from "@/types/analytics/analytics.time-off.types.ts";
import { ApiAnalyticsRecruitingFilter } from "@/types/analytics/analytics.recruiting.types.ts";

export const analyticsTimeOffApi = {
  balancesSummary: function (
    filter: ApiAnalyticsTimeOffBalanceSummaryFilter,
    signal?: AbortSignal
  ) {
    return api.post<ApiAnalyticsTimeOffBalanceSummaryReport>(
      `/api/v1/analytics/time-off/balance-report/summary`,
      filter,
      signal
    );
  },
  balancesSummaryExport: function (filter: ApiAnalyticsRecruitingFilter) {
    return api.post<BlobPart>(
      `/api/v1/analytics/time-off/balance-report/summary`,
      filter,
      undefined,
      {
        responseType: "blob",
      }
    );
  },
  balancesReport: function (filter: ApiAnalyticsTimeOffBalanceFilter, signal?: AbortSignal) {
    return api.post<ApiAnalyticsTimeOffBalanceReport>(
      `/api/v1/analytics/time-off/balance-report`,
      filter,
      signal
    );
  },
  balancesReportExport: function (filter: ApiAnalyticsTimeOffBalanceFilter) {
    return api.post<BlobPart>(`/api/v1/analytics/time-off/balance-report`, filter, undefined, {
      responseType: "blob",
    });
  },
  historyReport: function (filter: ApiAnalyticsTimeOffLeaveUsedFilter, signal?: AbortSignal) {
    return api.post<ApiAnalyticsTimeOffLeaveUsedReport>(
      `/api/v1/analytics/time-off/leave-used-report`,
      filter,
      signal
    );
  },
  historyReportExport: function (filter: ApiAnalyticsTimeOffLeaveUsedFilter) {
    return api.post<BlobPart>(`/api/v1/analytics/time-off/leave-used-report`, filter, undefined, {
      responseType: "blob",
    });
  },
  policyReport: function (filter: ApiAnalyticsTimeOffLeavePolicyFilter, signal?: AbortSignal) {
    return api.post<ApiAnalyticsTimeOffLeavePolicyReport>(
      `/api/v1/analytics/time-off/leave-policy-report`,
      filter,
      signal
    );
  },
  policyReportExport: function (filter: ApiAnalyticsTimeOffLeavePolicyFilter) {
    return api.post<BlobPart>(`/api/v1/analytics/time-off/leave-policy-report`, filter, undefined, {
      responseType: "blob",
    });
  },
};
